import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/platforms/index.vue') }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/platforms/form.vue') }
}

export class EditController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/platforms/form.vue') }

  static values = {
    backlinksPlatformId: String
  }

  connect() {
    super.connect({
      backlinksPlatformId: this.backlinksPlatformIdValue
    })
  }
}

export class BulkAddController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/platforms/bulk_add.vue') }
}

export class BulkDeletionController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/backlinks/platforms/bulk_deletion.vue') }
}
